import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
  CallCoreServicesAction,
} from "../../../appRedux/actions/CoreServicesAction";
function AdminLateralcephalo(props) {
  return <div>AdminLateralcephalo</div>;
}
const actionCreators = Object.assign(
  {},
  {
    CallCoreServicesAction,
    OfflineCoreServices,
    CallCoreServicesActionWithToken,
  }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});
const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
  token: state.coreservices.coreData?.token?.jwt?.data,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminLateralcephalo);
